import { makeStyles } from '@material-ui/core/styles'


const useStyles = makeStyles((theme) => ({
  additionalContentClasses: {
    paddingBottom: 24,
    paddingLeft: 24,
    paddingRight: 24
  },
  actionDescription: {
    textAlign: 'left'
  },
  dialogActionsClass: {
    paddingTop: 24,
    paddingBottom: 0,
    paddingLeft: 0,
    paddingRight: 0,
    display: 'flex',
    justifyContent: 'center',
    '& .MuiButtonBase-root': {
      width: '50%',
      paddingTop: 14,
      paddingBottom: 14,
      marginBottom: 0
    }
  }
}))

export default useStyles
